"use client";

import { useEffect, useState } from "react";
import { CHAPTERS } from "./data";

/* Rail fixo com scrollspy — mix-blend-difference funciona sobre
   capítulos claros e escuros sem trocar de cor manualmente. */
export default function Rail() {
  const [active, setActive] = useState<string | null>(null);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) setActive(e.target.id);
        }
      },
      { rootMargin: "-40% 0px -50% 0px" }
    );
    const sections = CHAPTERS.map((c) => document.getElementById(c.id)).filter(Boolean);
    sections.forEach((s) => io.observe(s!));

    // esconde o rail fora da zona de capítulos
    const first = sections[0];
    const last = sections[sections.length - 1];
    const onScroll = () => {
      if (!first || !last) return;
      const top = first.getBoundingClientRect().top;
      const bottom = last.getBoundingClientRect().bottom;
      const el = document.getElementById("cap-rail");
      if (el) el.style.opacity = top < window.innerHeight * 0.6 && bottom > 200 ? "1" : "0";
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      io.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <nav
      id="cap-rail"
      aria-label="Progresso dos capítulos"
      className="pointer-events-none fixed left-6 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-2.5 text-white opacity-0 transition-opacity duration-500 [mix-blend-mode:difference] xl:flex"
    >
      {CHAPTERS.map((c) => (
        <a
          key={c.id}
          href={`#${c.id}`}
          title={c.short}
          className="pointer-events-auto flex items-center gap-2"
        >
          <span
            className={`h-[2px] rounded bg-current transition-all duration-300 ${
              active === c.id ? "w-5 opacity-100" : "w-2.5 opacity-30"
            }`}
          />
          <span
            className={`font-sans text-[11px] font-bold tracking-wider transition-opacity ${
              active === c.id ? "opacity-100" : "opacity-35"
            }`}
          >
            {c.n}
          </span>
        </a>
      ))}
    </nav>
  );
}
